import { useMemo } from 'react';
import { HourlyCcuData, SummaryData } from './type';

interface UseSteamHourlyCCUProps {
  hourlyCcuRawItem?: any | null;
}

interface UseSteamHourlyCCUReturn {
  hourlyCcuData: HourlyCcuData | null;
  summaryData: SummaryData;
  isEmpty: boolean;
}

const EMPTY_SUMMARY: SummaryData = {
  value: null,
  dod: null,
  value_dod: null,
  sdlw: null,
  value_sdlw: null,
  date: null,
};

const useSteamHourlyCCU = (props: UseSteamHourlyCCUProps): UseSteamHourlyCCUReturn => {
  const { hourlyCcuRawItem } = props;

  return useMemo(() => {
    if (!hourlyCcuRawItem?.hourly_ccu) {
      return {
        hourlyCcuData: null,
        summaryData: EMPTY_SUMMARY,
        isEmpty: true,
      };
    }

    const ccuData = hourlyCcuRawItem.hourly_ccu;
    const todayHasData = ccuData?.today?.some(
      (item: any) => item?.value != null,
    );

    if (!todayHasData) {
      return {
        hourlyCcuData: null,
        summaryData: EMPTY_SUMMARY,
        isEmpty: true,
      };
    }

    return {
      hourlyCcuData: ccuData,
      summaryData: {
        value: hourlyCcuRawItem.value ?? null,
        dod: hourlyCcuRawItem.dod ?? ccuData?.dod ?? null,
        value_dod: hourlyCcuRawItem.value_dod ?? ccuData?.value_dod ?? null,
        sdlw: hourlyCcuRawItem.sdlw ?? ccuData?.sdlw ?? null,
        value_sdlw: hourlyCcuRawItem.value_sdlw ?? ccuData?.value_sdlw ?? null,
        date: hourlyCcuRawItem.date ?? ccuData?.base_date ?? null,
      },
      isEmpty: false,
    };
  }, [hourlyCcuRawItem]);
};

export default useSteamHourlyCCU;
